<script setup>
import { toRefs } from "vue";

const props = defineProps({
  color: String,
  icon: String,
  text: String,
  title: String,
});

const { color, text, icon, title } = toRefs(props);
</script>

<template>
  <div
    :class="`d-flex align-center justify-center flex-column box box-${color}`"
  >
    <div class="text-center stat">
      {{ text }}
    </div>
    <div class="d-flex align-center">
      <span class="ml-2 mb-2">
        {{ title }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.box {
  color: white;
  border-radius: 8px;
  min-height: 150px;
  .stat {
    font-weight: 900;
    font-size: 64px;
    line-height: 1.25em;
  }
  span {
    font-size: 18px;
    font-weight: 500;
    text-transform: uppercase;
  }
}
.box-primary {
  background: rgb(var(--v-theme-primary));
}
.box-academy {
  background: rgb(var(--v-theme-academy));
}
.box-employability {
  background: rgb(var(--v-theme-employability));
  color: black;
}
.box-company {
  background: rgb(var(--v-theme-company));
  color: black;
}
</style>
